module.exports = __webpack_public_path__ + "static/media/snow.53249813.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/snow.jpg
// module id = 3568
// module chunks = 0